import { CHANGE_LIST, INIT_FAIL, INIT_SUCCESS, UPDATE_FAIL, UPDATE_SUCCESS } from "../actions/evaluationCategory";

const initialState = {
  data: [],
  rows: [],
  categories: [],
  abolitionFlgText: [],
  abolitionFlgValue: [],
  list: [],
  age: null
};

const evaluationCategory = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INIT_SUCCESS:
      return {
        ...state,
        data: payload.data,
        rows: payload.rows,
        categories: payload.categories,
        abolitionFlgText: payload.abolitionFlgText,
        abolitionFlgValue: payload.abolitionFlgValue,
        list: payload.list,
        age: payload.age
      };
    case INIT_FAIL:
      return {
        ...state,
        message: payload.message,
        messageCode: payload.messageCode
      };
    case UPDATE_SUCCESS:
      return {
        ...state,
        params: payload.params
      };
    case UPDATE_FAIL:
      return {
        ...state,
        message: payload.message,
        error: payload.error
      };
    case CHANGE_LIST:
      return {
        ...state,
        rows: payload.rows,
        age: payload.age
      };
    default:
      return {
        ...state
      };
  }
};

export default evaluationCategory;
